import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  connectionsSummaryInformationText: {
    id: "funding-application: application summary information text",
    defaultMessage:
      "Check you’ve connected all your accounts before submitting. Missing platforms could delay your application.",
  },
  completeStepsPrompt: {
    id: "funding-application: complete all steps prompt",
    defaultMessage: "Have you added all your accounts?",
  },
  submitApplicationLabel: {
    id: "funding-application: submit application label",
    defaultMessage: "Submit Application",
  },
  connectedAccountsHeading: {
    id: "funding-application: connected accounts heading",
    defaultMessage: "Connected Accounts",
  },
  actionRequired: { id: "funding-application: action required", defaultMessage: "Action required" },
  actionCompleted: { id: "funding-application: action completed", defaultMessage: "Completed" },
  reviewAndSubmitTitle: {
    id: "funding-application: review and submit application title",
    defaultMessage: "Review & submit application",
  },
});
